export default __webpack_public_path__ + "static/media/caja-maquillaje.351a6122.png";